module.exports = __webpack_public_path__ + "img/background-todos-mobile.71eae55c.jpg";